const FilteredSelectize = function (opts) {
    Charcoal.Admin.Property_Input_Selectize.call(this, opts)
    this.input_type = 'charcoal/admin/property/input/selectize/FilteredSelectize';
}

FilteredSelectize.prototype = Object.create(Charcoal.Admin.Property_Input_Selectize.prototype);
FilteredSelectize.constructor = Charcoal.Admin.Property_Input_Selectize;
FilteredSelectize.parent = Charcoal.Admin.Property_Input_Selectize.prototype;

FilteredSelectize.prototype.set_properties = function (opts) {
    // this.remote_source = true

    Charcoal.Admin.Property_Input_Selectize.prototype.set_properties.call(this, opts);
    // Disabling some features of the selectize not compatible with the filtered selectize.
    this.selectize_options = $.extend(this.selectize_options, {
        create: false,
        createOnBlur: false,
        load: null,
        plugins: $.extend(this.selectize_options.plugins, {
            create_on_enter: false
        }),
        loadFilteredOptions: this.load_filtered_options.bind(this),
    })

    return this;
}

FilteredSelectize.prototype.init_selectize = function () {
    this.initValue = this.$input.val()
    Charcoal.Admin.Property_Input_Selectize.prototype.init_selectize.call(this);
    this.selectize.loadFilteredOptions = this.load_filtered_options.bind(this)
}


FilteredSelectize.prototype.load_filtered_options = function (filters, callback) {
    this.selectize.clearOptions(true);

    const type = this.obj_type,
        selectize_property_ident = this.selectize_property_ident,
        selectize_obj_type = this.selectize_obj_type,
        selectize_property = this.selectize_property,
        url = Charcoal.Admin.admin_url() + 'filtered-selectize/load';

    const form_data = {
        obj_type: type,
        selectize_obj_type: selectize_obj_type,
        selectize_prop_ident: selectize_property_ident,
        selectize_property: selectize_property,
        selectize_filters: filters,
    };

    $.ajax({
        url: url,
        type: 'GET',
        data: form_data,
        error: function () {},
        success: (response) => {
            if (response.optgroups !== null) {
                $.each(response.optgroups, function (index, optgroup) {
                    that.selectize.registerOptionGroup(optgroup);
                });
            }

            let options = [];

            if (response.selectize !== null) {
                options = response.selectize;
            } else {
                options = response;
            }

            if (!options.length) {
                callback(null);
                return false;
            }
            this.selectize.addOption(options)
            if (this.initValue) {
                this.selectize.setValue(this.initValue)
                this.initValue = null
            }

            this.selectize.refreshOptions(false);

            callback(options);
            return true
        }
    });
}

Charcoal.Admin.Property_Input_Selectize_FilteredSelectize = FilteredSelectize;
